import React, { useState, useEffect } from 'react';
import '../App.css';
import { useTranslation } from 'react-i18next';
import '../Styles/Home.css'; // 引入動畫樣式

function EquityResearch() {
  const { t } = useTranslation();
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // 頁面動畫載入效果
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 100);
    
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`article-container ${isLoaded ? 'content-loaded' : 'content-hidden'}`}>
      <h1 className={`${isLoaded ? 'fade-in-element' : ''}`}>{t('equityResearch.title')}</h1>
      <p className={`${isLoaded ? 'fade-in-element delay-1' : ''}`}>{t('equityResearch.comingSoon')}</p>
    </div>
  );
}

export default EquityResearch;
